// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 120px;
  max-height: 50px;
}

.mw120 {
  max-width: 120px;
}

.cartIcons {
  min-width: 25px;
  margin-right: 5px;
  margin-top: 5px;
  max-width: 30px !important;
}

.pos75 {
  position: absolute;
  left: 80%;
  top: 25%;
}

.langDropdown {
  color: #fff !important;
  border: 0px !important;
  background: unset;
}

.posRel {
  position: relative;
}

.visCol {
  visibility: collapse;
}

.mq30 {
  margin-right: 0px !important;
}

.posWebLanguage {
  position: absolute;
  top: -60%;
}

option {
  background: var(--ion-color-primary) !important;
  color: #fff !important;
}

.logoMainCol {
  max-width: 230px;
}

.mw135 {
  max-width: 135px;
}

.mw105 {
  max-width: 105px;
}

.mw117 {
  max-width: 117px;
}

.mw80 {
  max-width: 80px;
}

.logoMainColWithBack {
  max-width: 190px;
}

.logoMainMenu {
  max-width: 25px;
  margin-right: 5px;
}

.logoMainMenuRight {
  max-width: 25px;
  margin-right: 25px;
}

.innerPageTitle {
  max-width: 165px;
}

ion-icon {
  font-size: 25px;
}

.searchBarUpper {
  max-width: 300px;
  float: right;
}

.clsMenu {
  cursor: pointer;
  white-space: nowrap;
}

ion-back-button button {
  margin: 0px;
  padding: 0px;
}
ion-back-button button span {
  margin: 0px;
  padding: 0px;
}
ion-back-button button span ion-icon {
  margin: 0px;
  padding: 0px;
}

.coloredHeader ion-back-button {
  --icon-font-size: 32px;
}

@media screen and (max-width: 500px) {
  img {
    max-width: 120px;
    max-height: 50px;
  }
  .cartIcons {
    margin-right: 20px;
  }
}
@media screen and (max-width: 960px) {
  .toHideInSmallScreen {
    display: none;
  }
  .toShowInSmallScreen {
    display: block;
  }
  .toShowInSmallScreenFlex {
    display: flex;
  }
  .button-native.sc-ion-back-button-ios {
    color: var(--ion-color-primary) !important;
  }
  .button-inner.sc-ion-back-button-ios {
    color: var(--ion-color-primary) !important;
  }
}
#chat-btn {
  position: relative;
}

#chat-badge {
  font-size: 10px;
  border-radius: 10px;
  color: white;
  background-color: red;
  padding-left: 5px;
  padding-right: 5px;
  top: 0px;
  position: absolute;
}

.label-color {
  color: var(--ion-color-header-label);
}

.menuNotSelected {
  user-select: none;
  color: var(--ion-color-header-label);
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

.menuSelected {
  font-weight: bold;
  text-decoration: underline;
  text-underline-offset: 4px;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

.logo {
  max-height: 50px;
  /* Override the global \`img { max-width: 120px }\` cap so the wide
     KGIRDHARLAL wordmark isn't squashed into a thin strip on web */
  max-width: 220px;
  width: auto;
  height: auto;
  object-fit: contain;
  left: 4px;
  position: relative;
  top: -2px;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

.searchBarUpperRmWidth {
  float: right;
}

@media only screen and (max-width: 500.98px) {
  .largescreen {
    display: none;
    visibility: hidden;
  }
  .smallScreen {
    display: block;
    visibility: visible;
  }
}
@media only screen and (min-width: 501px) {
  .smallScreen {
    display: none;
    visibility: hidden;
  }
  .largescreen {
    display: block;
    visibility: visible;
  }
}
.title-font {
  font-size: 6vw !important;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

#scroll-container {
  border-radius: 5px;
  overflow: hidden;
}

#scroll-text {
  text-align: right;
  color: red;
  text-decoration: underline;
  cursor: pointer;
  /* animation properties */
  transform: translateX(-100%);
  animation: my-animation 40s linear infinite;
}

/* for Firefox */
/* for Chrome */
@keyframes my-animation {
  from {
    transform: translateX(80%);
  }
  to {
    transform: translateX(-100%);
  }
}
@media only screen and (max-width: 500px) {
  #scroll-text {
    font-size: 3vw;
  }
  .hideInMobileView {
    display: none;
  }
}
.stoneCol {
  max-width: 250px;
}

.stoneTextbox {
  width: 200px;
  margin: 2px;
  border-radius: 80px;
  height: 37px;
}

::ng-deep .searchbar-input {
  width: 200px;
  border-radius: 80px !important;
  height: 37px;
}

::ng-deep input-searchbar input {
  padding-inline-start: 10px !important;
  padding-inline-end: 10px !important;
}

.popover__wrapper {
  position: relative;
  display: inline-block;
}

.popover__content {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  transform: translate(0, 10px);
  background-color: white;
  padding: 1.5rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  width: auto;
  top: 35px;
}

.popover__content:before {
  position: absolute;
  z-index: -1;
  content: "";
  right: calc(50% - 10px);
  top: -8px;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #bfbfbf transparent;
  transition-duration: 0.3s;
  transition-property: transform;
}

.popover__wrapper:hover .popover__content {
  z-index: 10;
  opacity: 1;
  visibility: visible;
  transform: translate(0, -20px);
  transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}

.popover__message {
  text-align: center;
}

@media (min-width: 960px) and (max-width: 1500px) {
  .mq30 {
    margin-right: 30px !important;
  }
}
.menu-label-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ============================================================
   Language selector — globe trigger + Stripe-style dropdown card
   ============================================================ */
.lang-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.lang-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  line-height: 0;
  cursor: pointer;
  /* Inherit the toolbar's text color so the globe is white like the cart,
     while \`color="headerIconColor"\` still wins where that color is defined */
  color: inherit;
  transition: transform 0.15s ease;
  /* Match the cart / person icons exactly (see global \`ion-icon { 25px }\`) */
}
.lang-trigger ion-icon {
  font-size: 25px;
}
.lang-trigger:active {
  transform: scale(0.94);
}
.lang-trigger:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  border-radius: 4px;
}

/* The dropdown card itself (.lang-menu / .lang-option / .lang-popover sizing)
   lives in global.scss — it renders in the Ionic overlay layer and is shared
   with the mobile side-menu language selector. */`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;AAEF;;AAAA;EACE,kBAAA;EAEA,SAAA;EACA,QAAA;AAEF;;AACA;EAEE,sBAAA;EACA,sBAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;;AADA;EACE,4BAAA;AAIF;;AAFA;EACE,kBAAA;EAEA,SAAA;AAIF;;AAFA;EACE,+CAAA;EACA,sBAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,eAAA;EACA,iBAAA;AAMF;;AAHA;EACE,eAAA;EACA,kBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,gBAAA;EACA,YAAA;AAMF;;AAHA;EACE,eAAA;EACA,mBAAA;AAMF;;AAFE;EACE,WAAA;EACA,YAAA;AAKJ;AAHI;EACE,WAAA;EACA,YAAA;AAKN;AAHM;EACE,WAAA;EACA,YAAA;AAKR;;AAEE;EACE,sBAAA;AACJ;;AAGA;EACE;IACE,gBAAA;IACA,gBAAA;EAAF;EAGA;IACE,kBAAA;EADF;AACF;AAIA;EACE;IACE,aAAA;EAFF;EAKA;IACE,cAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,0CAAA;EALF;EAQA;IACE,0CAAA;EANF;AACF;AASA;EACE,kBAAA;AAPF;;AAUA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AASA;EACE,iBAAA;EACA,oCAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AANF;;AASA;EACE,iBAAA;EACA,0BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AANF;;AASA;EACE,gBAAA;EACA;mEAAA;EAEA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE;IACE,aAAA;IACA,kBAAA;EANF;EASA;IACE,cAAA;IACA,mBAAA;EAPF;AACF;AAUA;EACE;IACE,aAAA;IACA,kBAAA;EARF;EAWA;IACE,cAAA;IACA,mBAAA;EATF;AACF;AAYA;EACE,yBAAA;EACA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAVF;;AAaA;EAEE,kBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,4BAAA;EAIA,2CAAA;AAZF;;AAeA,gBAAA;AAWA,eAAA;AAWA;EACE;IAGE,0BAAA;EAhBF;EAmBA;IAGE,4BAAA;EAjBF;AACF;AAoBA;EACE;IACE,cAAA;EAlBF;EAqBA;IACE,aAAA;EAnBF;AACF;AAsBA;EACE,gBAAA;AApBF;;AAsBA;EACE,YAAA;EAGA,WAAA;EACA,mBAAA;EACA,YAAA;AArBF;;AAuBA;EACE,YAAA;EACA,8BAAA;EACA,YAAA;AApBF;;AAwBE;EACE,qCAAA;EACA,mCAAA;AArBJ;;AAkCA;EACE,kBAAA;EAEA,qBAAA;AAhCF;;AAkCA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EAEA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,WAAA;EACA,SAAA;AAhCF;;AAkCA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;EACA,yBAAA;EACA,8BAAA;AA/BF;;AAiCA;EACE,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;AA9BF;;AAgCA;EACE,kBAAA;AA7BF;;AAgCA;EACE;IACE,6BAAA;EA7BF;AACF;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjCF;;AAoCA;;iEAAA;AAGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA;6EAAA;EAEA,cAAA;EACA,gCAAA;EAEA,2EAAA;AAlCF;AAmCE;EACE,eAAA;AAjCJ;AAoCE;EACE,sBAAA;AAlCJ;AAqCE;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;AAnCJ;;AAuCA;;iDAAA","sourcesContent":["img {\n  max-width: 120px;\n  max-height: 50px;\n}\n\n.mw120 {\n  max-width: 120px;\n}\n\n.cartIcons {\n  min-width: 25px;\n  margin-right: 5px;\n  margin-top: 5px;\n  max-width: 30px !important;\n}\n.pos75 {\n  position: absolute;\n  // left: 75%;\n  left: 80%;\n  top: 25%;\n}\n\n.langDropdown {\n  // color: #000 !important;\n  color: #fff !important;\n  border: 0px !important;\n  background: unset;\n}\n.posRel {\n  position: relative;\n}\n.visCol {\n  visibility: collapse;\n}\n.mq30 {\n  margin-right: 0px !important;\n}\n.posWebLanguage {\n  position: absolute;\n  // left: 16%;\n  top: -60%;\n}\noption {\n  background: var(--ion-color-primary) !important;\n  color: #fff !important;\n}\n.logoMainCol {\n  max-width: 230px;\n}\n\n.mw135 {\n  max-width: 135px;\n}\n\n.mw105 {\n  max-width: 105px;\n}\n\n.mw117 {\n  max-width: 117px;\n}\n\n.mw80 {\n  max-width: 80px;\n}\n\n.logoMainColWithBack {\n  max-width: 190px;\n}\n\n.logoMainMenu {\n  max-width: 25px;\n  margin-right: 5px;\n}\n\n.logoMainMenuRight {\n  max-width: 25px;\n  margin-right: 25px;\n}\n\n.innerPageTitle {\n  max-width: 165px;\n}\n\nion-icon {\n  font-size: 25px;\n}\n\n.searchBarUpper {\n  max-width: 300px;\n  float: right;\n}\n\n.clsMenu {\n  cursor: pointer;\n  white-space: nowrap;\n}\n\nion-back-button {\n  button {\n    margin: 0px;\n    padding: 0px;\n\n    span {\n      margin: 0px;\n      padding: 0px;\n\n      ion-icon {\n        margin: 0px;\n        padding: 0px;\n      }\n    }\n  }\n}\n\n.coloredHeader {\n  ion-back-button {\n    --icon-font-size: 32px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  img {\n    max-width: 120px;\n    max-height: 50px;\n  }\n\n  .cartIcons {\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 960px) {\n  .toHideInSmallScreen {\n    display: none;\n  }\n\n  .toShowInSmallScreen {\n    display: block;\n  }\n\n  .toShowInSmallScreenFlex {\n    display: flex;\n  }\n\n  .button-native.sc-ion-back-button-ios {\n    color: var(--ion-color-primary) !important;\n  }\n\n  .button-inner.sc-ion-back-button-ios {\n    color: var(--ion-color-primary) !important;\n  }\n}\n\n#chat-btn {\n  position: relative;\n}\n\n#chat-badge {\n  font-size: 10px;\n  border-radius: 10px;\n  color: white;\n  background-color: red;\n  padding-left: 5px;\n  padding-right: 5px;\n  top: 0px;\n  position: absolute;\n  //right: -5px;\n}\n.label-color {\n  color: var(--ion-color-header-label);\n}\n.menuNotSelected {\n  user-select: none;\n  color: var(--ion-color-header-label);\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.menuSelected {\n  font-weight: bold;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.logo {\n  max-height: 50px;\n  /* Override the global `img { max-width: 120px }` cap so the wide\n     KGIRDHARLAL wordmark isn't squashed into a thin strip on web */\n  max-width: 220px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  left: 4px;\n  position: relative;\n  top: -2px;\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.searchBarUpperRmWidth {\n  float: right;\n}\n\n@media only screen and (max-width: 500.98px) {\n  .largescreen {\n    display: none;\n    visibility: hidden;\n  }\n\n  .smallScreen {\n    display: block;\n    visibility: visible;\n  }\n}\n\n@media only screen and (min-width: 501px) {\n  .smallScreen {\n    display: none;\n    visibility: hidden;\n  }\n\n  .largescreen {\n    display: block;\n    visibility: visible;\n  }\n}\n\n.title-font {\n  font-size: 6vw !important;\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n#scroll-container {\n  // border: 3px solid black;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n#scroll-text {\n  text-align: right;\n  color: red;\n  text-decoration: underline;\n  cursor: pointer;\n  /* animation properties */\n  -moz-transform: translateX(-100%);\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n\n  -moz-animation: my-animation 40s linear infinite;\n  -webkit-animation: my-animation 40s linear infinite;\n  animation: my-animation 40s linear infinite;\n}\n\n/* for Firefox */\n@-moz-keyframes my-animation {\n  from {\n    -moz-transform: translateX(80%);\n  }\n\n  to {\n    -moz-transform: translateX(-100%);\n  }\n}\n\n/* for Chrome */\n@-webkit-keyframes my-animation {\n  from {\n    -webkit-transform: translateX(80%);\n  }\n\n  to {\n    -webkit-transform: translateX(-100%);\n  }\n}\n\n@keyframes my-animation {\n  from {\n    -moz-transform: translateX(80%);\n    -webkit-transform: translateX(80%);\n    transform: translateX(80%);\n  }\n\n  to {\n    -moz-transform: translateX(-100%);\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  #scroll-text {\n    font-size: 3vw;\n  }\n\n  .hideInMobileView {\n    display: none;\n  }\n}\n\n.stoneCol {\n  max-width: 250px;\n}\n.stoneTextbox {\n  width: 200px;\n\n  // border: 1.5px solid white;\n  margin: 2px;\n  border-radius: 80px;\n  height: 37px;\n}\n::ng-deep .searchbar-input {\n  width: 200px;\n  border-radius: 80px !important;\n  height: 37px;\n}\n\n::ng-deep input-searchbar {\n  input {\n    padding-inline-start: 10px !important;\n    padding-inline-end: 10px !important;\n  }\n}\n\n.popover__title {\n  // font-size: 24px;\n  // line-height: 36px;\n  // text-decoration: none;\n  // //color: rgb(228, 68, 68);\n  // text-align: center;\n  // padding: 15px 0;\n}\n\n.popover__wrapper {\n  position: relative;\n  // margin-top: 1.5rem;\n  display: inline-block;\n}\n.popover__content {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  // left: -150px;\n  transform: translate(0, 10px);\n  background-color: #ffff;\n  padding: 1.5rem;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  width: auto;\n  top: 35px;\n}\n.popover__content:before {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  right: calc(50% - 10px);\n  top: -8px;\n  border-style: solid;\n  border-width: 0 10px 10px 10px;\n  border-color: transparent transparent #bfbfbf transparent;\n  transition-duration: 0.3s;\n  transition-property: transform;\n}\n.popover__wrapper:hover .popover__content {\n  z-index: 10;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -20px);\n  transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n.popover__message {\n  text-align: center;\n}\n\n@media (min-width: 960px) and (max-width: 1500px) {\n  .mq30 {\n    margin-right: 30px !important;\n  }\n  // .posWebLanguage {\n  //   left: 20%;\n  // }\n}\n\n.menu-label-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ============================================================\n   Language selector — globe trigger + Stripe-style dropdown card\n   ============================================================ */\n.lang-selector {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.lang-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent;\n  line-height: 0;\n  cursor: pointer;\n  /* Inherit the toolbar's text color so the globe is white like the cart,\n     while `color=\"headerIconColor\"` still wins where that color is defined */\n  color: inherit;\n  transition: transform 0.15s ease;\n\n  /* Match the cart / person icons exactly (see global `ion-icon { 25px }`) */\n  ion-icon {\n    font-size: 25px;\n  }\n\n  &:active {\n    transform: scale(0.94);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n}\n\n/* The dropdown card itself (.lang-menu / .lang-option / .lang-popover sizing)\n   lives in global.scss — it renders in the Ionic overlay layer and is shared\n   with the mobile side-menu language selector. */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
